<!-- Persoana fizica -->
<div class="g-0">
    <div class="row">
        <div class="col">
            <div class="box-wrapper box-info">
                <div class="box-content-header">
                    <div class="row p-1">
                        <div class="col">
                            <div class="d-flex justify-content-between align-items-center">
                                <mat-card-title>
                                    <i class="fa-solid fa-user"></i>
                                    <span>Conținut Document</span>
                                </mat-card-title>
                                <button *ngIf="(currentUser.id_user === data.id_user || 
                                    permissionsService.hasPermission('indoc-module.registratura_documents.operations-admin.update-beneficiar-document')) 
                                    && data.current_status !== 4" class="btn btn-small btn-warning edit-btn"
                                    (click)="openEditContinutDocument()">
                                    <i class="fa fa-pencil fa-sm"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box-content-body">
                    <table class="table table-condensed">
                        <tbody>
                            <!-- if we have entity, please fill!!! -->
                            <tr *ngIf="data.entity !== null">
                                <td width="33%"><strong>Tip Persoană/Instituție</strong></td>
                                <td width="33%"><strong>Denumire</strong></td>
                                <td width="33%"><strong>Persoană Contact</strong></td>
                            </tr>

                            <tr *ngIf="data.entity !== null">
                                <td>{{data.entity.type || 'n/a'}}</td>
                                <td>{{data.entity.denumire || 'n/a'}}</td>
                                <td>{{data.entity.pers_contact || 'n/a'}}</td>
                            </tr>

                            <tr *ngIf="data.entity !== null && data.entity.id_address_type !== 4">
                                <td><strong>CNP/CUI</strong></td>
                                <td><strong>Email</strong></td>
                                <td><strong>Telefon</strong></td>
                            </tr>

                            <tr *ngIf="data.entity !== null && data.entity.id_address_type !== 4">
                                <td>{{data.entity.cnp_cui || 'n/a'}}</td>
                                <td>{{data.entity.email || 'n/a'}}</td>
                                <td>{{data.entity.telefon || 'n/a'}}</td>
                            </tr>

                            <tr *ngIf="data.entity !== null && data.entity.id_address_type !== 4">
                                <td><strong>Adresă</strong></td>
                                <td colspan="2"><strong>Obs Adresă</strong></td>
                            </tr>

                            <tr *ngIf="data.entity !== null && data.entity.id_address_type !== 4">
                                <td>{{('Țară: ' + (data.entity.name_tara ?
                                    data.entity.name_tara : 'n/a') + ', ') +
                                    ('Jud: ' + (data.entity.name_judet ? data.entity.name_judet :
                                    'n/a') + ', ') +
                                    ('Oraș: ' + (data.entity.name_localitate ? data.entity.name_localitate :
                                    'n/a') + ', ') +
                                    ('Sect: ' + (data.entity.sector && data.entity.sector != '-1' ? data.entity.sector :
                                    'n/a') + ', ') +
                                    ('Stradă: ' + (data.entity.name_strada ?data.entity.name_strada :
                                    'n/a') + ', ') +
                                    ('Nr: ' + (data.entity.numar ? data.entity.numar :
                                    'n/a') + ', ') +
                                    ('Bl: ' + (data.entity.bloc ? data.entity.bloc :
                                    'n/a') + ', ') +
                                    ('Sc: ' + (data.entity.scara ? data.entity.scara :
                                    'n/a') + ', ') +
                                    ('Et: ' + (data.entity.etaj ? data.entity.etaj :
                                    'n/a') + ', ') +
                                    ('Ap: ' + (data.entity.apartament ? data.entity.apartament :
                                    'n/a') + ', ') +
                                    ('CP: ' + (data.entity.cod_postal ? data.entity.cod_postal :
                                    'n/a'))}}</td>
                                <td colspan="2">{{data.entity.observatii || 'n/a'}}</td>
                            </tr>

                            <tr *ngIf="data.entity !== null && data.entity.id_address_type !== 4">
                                <td><strong>Număr certificat deces</strong></td>
                                <td><strong>Dată deces</strong></td>
                                <td><strong>Verificare evidența persoanelor</strong></td>
                            </tr>

                            <tr *ngIf="data.entity !== null && data.entity.id_address_type !== 4">
                                <td>{{data.entity.numar_deces || 'n/a'}}</td>
                                <td>{{data.entity.data_deces || 'n/a'}}</td>
                                <td>{{data.entity.person_status ? 'DA' : 'NU'}}</td>
                            </tr>

                            <tr *ngIf="data.entity !== null && data.entity.id_address_type === 4">
                                <td><strong>Directie/Institutie</strong></td>
                                <td><strong>Departament/Compartiment</strong></td>
                                <td><strong>Operator</strong></td>
                            </tr>
                            <tr *ngIf="data.entity !== null && data.entity.id_address_type === 4">
                                <td>{{data.entity.directie_name || 'n/a'}}</td>
                                <td>{{data.entity.compartiment_name || 'n/a'}}</td>
                                <td>{{data.entity.user_name || 'n/a'}}</td>
                            </tr>

                            <!-- button section.. to update -->
                            <!-- ng-click="pdrc.updateObservatiiDocument()"
                                        ng-if="pdrc.document.current_status !== 4 && (pdrc.document.id_user == pdrc.me.id_user ||
                                        pdrc.me.permissions_submodules.includes('dgaspc_registratura_document_admin_actualizare_observatii_force'))" -->
                            <tr>
                                <td class="d-flex align-items-center">
                                    <strong>Observații Document Registratură</strong>
                                    <button *ngIf="(currentUser.id_user === data.id_user || 
                                        permissionsService.hasPermission('indoc-module.registratura_documents.operations-admin.update-observatii-document')) 
                                        && data.current_status !== 4"
                                        class="ms-2 btn btn-small btn-warning edit-btn-obs"
                                        (click)="openEditObservatiiDocument()">
                                        <i class="fa fa-pencil fa-xs"></i>
                                    </button>
                                </td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{{ data.observatii ? data.observatii : 'n/a' }}</td>
                                <td></td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Emitent extern -->
<div class="g-0">
    <div class="row">
        <div class="col">
            <div class="box-wrapper box-info">
                <div class="box-content-header">
                    <div class="row p-1">
                        <div class="col">
                            <div class="d-flex justify-content-between align-items-center">
                                <mat-card-title>
                                    <i class="fa-solid fa-user"></i>
                                    <span>Emitent Extern</span>
                                </mat-card-title>
                                <button *ngIf="(currentUser.id_user === data.id_user || 
                                    permissionsService.hasPermission('indoc-module.registratura_documents.operations-admin.update-emitent-document')) 
                                    && data.current_status !== 4" class="btn btn-small btn-warning edit-btn"
                                    (click)="openEditEmitentExtern()">
                                    <i class="fa fa-pencil fa-sm"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box-content-body">
                    <table class="table table-condensed">
                        <tbody>
                            <!-- if we have entity extern, please fill!!! -->
                            <tr *ngIf="data.entity_emitent_extern !== null">
                                <td width="33%"><strong>Serie Extern</strong></td>
                                <td width="33%"><strong>Număr Extern</strong></td>
                                <td width="33%"><strong></strong></td>
                            </tr>

                            <tr *ngIf="data.entity_emitent_extern !== null">
                                <td>{{data.serie_pv ? data.serie_pv : 'n/a'}}</td>
                                <td>{{data.extern_numar ? data.extern_numar : 'n/a'}}</td>
                                <td></td>
                            </tr>

                            <tr *ngIf="data.entity_emitent_extern !== null">
                                <td><strong>Dată emitere(extern)</strong></td>
                                <td><strong>Dată comunicare(extern)</strong></td>
                                <td><strong></strong></td>
                            </tr>

                            <tr *ngIf="data.entity_emitent_extern !== null">
                                <td>{{data.extern_date ? data.extern_date :'n/a'}}</td>
                                <td>{{data.data_comunicare_pv ? data.data_comunicare_pv :'n/a'}}</td>
                                <td></td>
                            </tr>

                            <tr *ngIf="data.entity_emitent_extern !== null">
                                <td><strong>Denumire Emitent</strong></td>
                                <td><strong>Email Emitent</strong></td>
                                <td><strong>Telefon Emitent</strong></td>
                            </tr>

                            <tr *ngIf="data.entity_emitent_extern !== null">
                                <td>{{data.entity_emitent_extern.denumire ? data.entity_emitent_extern.denumire :
                                    'n/a'}}</td>
                                <td>{{data.entity_emitent_extern.email ? data.entity_emitent_extern.email : 'n/a'}}</td>
                                <td>{{data.entity_emitent_extern.telefon ? data.entity_emitent_extern.telefon : 'n/a'}}
                                </td>
                            </tr>

                            <tr *ngIf="data.entity_emitent_extern !== null">
                                <td>
                                    <strong>Adresă Emitent Extern</strong>
                                </td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr *ngIf="data.entity_emitent_extern !== null">
                                <td>{{('Țară: ' + (data.entity_emitent_extern.name_tara ?
                                    data.entity_emitent_extern.name_tara :
                                    'n/a') + ', ') +
                                    ('Jud: ' + (data.entity_emitent_extern.name_judet ?
                                    data.entity_emitent_extern.name_judet :
                                    'n/a') + ', ') +
                                    ('Oraș: ' + (data.entity_emitent_extern.name_localitate ?
                                    data.entity_emitent_extern.name_localitate :
                                    'n/a') + ', ') +
                                    ('Sect: ' + (data.entity_emitent_extern.sector && data.entity_emitent_extern.sector
                                    != '-1' ? data.entity_emitent_extern.sector : 'n/a') + ', ') +
                                    ('Stradă: ' + (data.entity_emitent_extern.name_strada ?
                                    data.entity_emitent_extern.name_strada : 'n/a') + ', ') +
                                    ('Nr: ' + (data.entity_emitent_extern.numar ? data.entity_emitent_extern.numar :
                                    'n/a') + ', ') +
                                    ('Bl: ' + (data.entity_emitent_extern.bloc ? data.entity_emitent_extern.bloc :
                                    'n/a') + ', ') +
                                    ('Sc: ' + (data.entity_emitent_extern.scara ? data.entity_emitent_extern.scara :
                                    'n/a') + ', ') +
                                    ('Et: ' + (data.entity_emitent_extern.etaj ? data.entity_emitent_extern.etaj :
                                    'n/a') + ', ') +
                                    ('Ap: ' + (data.entity_emitent_extern.apartament ?
                                    data.entity_emitent_extern.apartament :
                                    'n/a') + ', ') +
                                    ('CP: ' + (data.entity_emitent_extern.cod_postal ?
                                    data.entity_emitent_extern.cod_postal :
                                    'n/a'))}}</td>
                                <td></td>
                                <td></td>
                            </tr>

                            <tr *ngIf="data.entity_emitent_extern !== null">
                                <td>
                                    <strong>Observații Adresă Emitent Extern</strong>
                                </td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr *ngIf="data.entity_emitent_extern !== null">
                                <td>{{ data.entity_emitent_extern.observatii ? data.entity_emitent_extern.observatii :
                                    'n/a' }}</td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr *ngIf="data.entity_emitent_extern == null">
                                <td colspan="3" class="text-center">
                                    <p><strong><i>Lipsă înregistrări</i></strong></p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>